import React, { useMemo } from "react";
import AdminNavbar from "../admin/dashboard/AdminNavbar";
import { Container } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const AdminLayout = (props) => {
  const location = useLocation();
  const showAdminHeader = useMemo(
    () =>
      location.pathname.includes("/admin") ||
      location.pathname.startsWith("/inbox"),
    [location]
  );

  return (
    <div>
      {showAdminHeader && <AdminNavbar user={props.user} />}

      <Container style={{ marginTop: 20 }}>{props.children}</Container>
    </div>
  );
};

export default AdminLayout;
